export default __webpack_public_path__ + "static/media/Indiana.66f43e6e.ttf";